/**
 * @typedef {{ label, values: [] }[]} DataSet
 */
/**
 * data: { label, values: [] }[],
 * sublabels: [],
 * subcolors: []
 * 
 */


import "../styles/bar.css";

/** @param {DataSet} data */
function getBounds(data) {
    let min = null;
    let max = null;

    const upperBounds = [
        10, 50, 100, 200, 500, 750, 1000, 1500, 2000, 3000, 5000,
        7_500, 10_000, 15_000, 20_000, 30_000, 50_000, 
        75_000, 100_000, 120_000, 150_000, 200_000, 300_000,
        400_000, 500_000, 750_000, 1_000_000
    ];

    data.forEach(item => {
        item.values.forEach(value => {
            if(!min || value < min) min = value;
            if(!max || value > max) max = value;
        })
    });

    const upperBound = upperBounds.find(ub => max < ub);

    const sections = [];
    for(let i = 1; i <= 5; i++) sections.push((upperBound/5)*i);

    return { lower: 0, upper: upperBound, sections };
}


/**
 * @param {{ data: DataSet, sublabels: string[], subcolors: string[] }} param0 
 */
export function BarGraph({ data, sublabels, subcolors }) {
    const bounds = getBounds(data);
    
    const barGroups = [];
    const valueGroups = [];

    data.forEach((item, i) => {
        const { values } = item;

        const bars = [];
        const valueItems = [];
        
        values.map((value, vi) => {
            const fraction = (value / bounds.upper) * 100;
            const color = subcolors[vi];

            bars.push(<div className="bar-frame" key={vi}>
                <div className="bar" style={{ backgroundColor: color, height: fraction + "%" }} />
            </div>);

            valueItems.push(<div key={vi} className="value">{value}</div>);
        });



        barGroups.push(<div className="bar-group" key={i}>{bars}</div>);
        valueGroups.push(<div className="value-group" key={i}>{valueItems}</div>);
    });


    return <div className="bar-chart">
        <section className="values">{valueGroups}</section>
        <section className="bars-section">
            <div className="lines">
                {
                    bounds.sections.map((section, i) => 
                        <div className="line-section" style={{ bottom: ((i+1)*20)+"%" }} key={i}>
                            <div className="value">{section}</div>
                            <div className="line" />
                        </div>)
                }
                <div className="line-section bottom">
                    <div className="value"></div><div className="line bottom" />
                </div>
            </div>
            <div className="bars">{barGroups}</div>
        </section>
        <section className="labels">{
            data.map((item, i) => <div className="label" key={i}>{item.label}</div>)
        }</section>
        <section className="legend">{
            sublabels.map((sublabel, i) => 
            <div className="sublabel-item" key={i}>
                <div className="color" style={{ backgroundColor: subcolors[i] }} />
                <span>{sublabel}</span>
            </div>)
        }</section>
    </div>;
}


